import { Tooltip } from '@eppendorf/vnls-react-components';
import { Text } from '@eppendorf/vnls-react-components-preview';
import { useRef, useState, type ReactNode } from 'react';

interface TruncatedTextProps {
  text?: string;
  children?: ReactNode;
  className?: string;
}

export function TruncatedText({ text, children, className }: TruncatedTextProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const content = children ?? text;

  return (
    <Tooltip
      isOpen={isOpen}
      delayDuration={300}
      onOpenChange={(open) => {
        const element = ref.current;
        setIsOpen(
          Boolean(
            open &&
            element &&
            (element.scrollWidth > element.clientWidth ||
              element.scrollHeight > element.clientHeight),
          ),
        );
      }}
      trigger={
        <Text ref={ref} truncate tabIndex={0} className={className}>
          {content}
        </Text>
      }
    >
      <div className="dashboard-tooltip">{content}</div>
    </Tooltip>
  );
}
